import React from 'react'
import { UnstyledAnchor } from './unstyled-link.component'

export function DownloadAnchor(props: React.HTMLProps<HTMLAnchorElement>) {
  return <UnstyledAnchor {...props} target="_blank" rel="noreferrer" />
}
